module.exports = __webpack_public_path__ + "img/jn-bottom.1d3d14bd.png";